export default "__VITE_ASSET__GVD5CCZC__"